import { parseStringToNumberOrUndefined } from '../../domain/parseNumber';
import { ParsedRecord } from '../import/ImportParser';
import { SITE_RAP_PARTICIPATION_TYPES, SITE_RAP_PRIMARY_LOAD_TYPES, SITE_RAP_REDUCTION_TYPES, SiteRapsCsvColumns } from './constants';

export function siteRapsParser(row: ParsedRecord<SiteRapsCsvColumns>): ParsedRecord<SiteRapsCsvColumns> {
    row = isNumber<SiteRapsCsvColumns>(row, 'Site ID*');

    row = isNotEmptyStringHandler<SiteRapsCsvColumns>(row, 'Site Name*');
    row = isNotEmptyStringHandler<SiteRapsCsvColumns>(row, 'Site Address*');
    row = isNotEmptyStringHandler<SiteRapsCsvColumns>(row, 'Site Status*');

    row = isOptionalOneOfHandler<SiteRapsCsvColumns>(row, 'Participation Type', SITE_RAP_PARTICIPATION_TYPES);
    row = isOptionalOneOfHandler<SiteRapsCsvColumns>(row, 'Reduction Type', SITE_RAP_REDUCTION_TYPES);
    row = isOptionalOneOfHandler<SiteRapsCsvColumns>(row, 'Primary Load Type', SITE_RAP_PRIMARY_LOAD_TYPES);
    row = isOptionalStringHandler<SiteRapsCsvColumns>(row, 'Curtailment Strategy');
    row = isOptionalStringHandler<SiteRapsCsvColumns>(row, 'Reduction Action Plan');

    return row;
}

function isNotEmptyStringHandler<T extends string>(row: ParsedRecord<T>, key: T) {
    if (row[key].value === '') {
        row[key].error = `"${key}" is required`;
    } else {
        row[key].parsedValue = row[key].value;
    }

    return row;
}

function isOptionalStringHandler<T extends string>(row: ParsedRecord<T>, key: T) {
    if (!row[key] || !row[key].value || row[key].value.trim() === '') {
        row[key] = row[key] || { value: '', parsedValue: null, error: '' };
        row[key].parsedValue = null;
    } else {
        row[key].parsedValue = row[key].value;
    }
    return row;
}

function isOptionalOneOfHandler<T extends string>(row: ParsedRecord<T>, key: T, allowedOptions: any[]) {
    if (!row[key] || !row[key].value || row[key].value.trim() === '') {
        row[key] = row[key] || { value: '', parsedValue: null, error: '' };
        row[key].parsedValue = null;
        return row;
    }

    const val = String(row[key].value).toLowerCase();
    const foundOptionIndex = allowedOptions.map(it => it.toLowerCase()).findIndex(it => it === val);
    if (foundOptionIndex === -1) {
        row[key].error = `"${key}" must be one of: ${JSON.stringify(allowedOptions)}`;
    } else {
        row[key].parsedValue = allowedOptions[foundOptionIndex];
    }

    return row;
}

function isNumber<T extends string>(row: ParsedRecord<T>, key: T) {
    const num = parseStringToNumberOrUndefined(row[key].value);
    if (num === undefined) {
        row[key].error = `"${key}" is not a number`;
    } else {
        row[key].parsedValue = num;
    }

    return row;
}
